import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { MarketProvider } from "@context/MarketContext";
import { useMarkets } from "@context/marketsContext";
import Template1 from "../Templates/Template1";
import { useUserState } from "@features/User/context";
import Template2 from "../Templates/Template2";
import Template3 from "../Templates/Template3";

const MarketPage = () => {
  const user = useUserState();
  const layout = user?.user?.setting?.layout || "template2";
  const { currencyName } = useParams();
  const history = useHistory();
  const { isLoaded, getMarketByRoute, defaultMarketRoute } = useMarkets();

  useEffect(() => {
    if (!isLoaded || !currencyName) return;

    if (!getMarketByRoute(currencyName) && defaultMarketRoute) {
      history.replace(`/market/${defaultMarketRoute}`);
    }
  }, [
    isLoaded,
    currencyName,
    getMarketByRoute,
    defaultMarketRoute,
    history,
  ]);

  const getTemplate = (layoutTemplate) => {
    switch (layoutTemplate) {
      case "template1":
        return <Template1 />;
      case "template2":
        return <Template2 />;
      case "template3":
        return <Template3 />;
      default:
        return <Template2 />;
    }
  };

  return <MarketProvider>{getTemplate(layout)}</MarketProvider>;
};

export default MarketPage;
